import { render, staticRenderFns } from "./customerDialog.vue?vue&type=template&id=18ff55e9&scoped=true&"
import script from "./customerDialog.vue?vue&type=script&lang=js&"
export * from "./customerDialog.vue?vue&type=script&lang=js&"
import style0 from "./customerDialog.vue?vue&type=style&index=0&id=18ff55e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ff55e9",
  null
  
)

export default component.exports